export default __webpack_public_path__ + "static/media/Governance.6c2ad8cb.svg";